import { InvoicingDefaultSettlementDate } from '@query'
import dayjs from 'dayjs'

export const defaultSettlementDate = (
  invoicingDate: string,
  rule: InvoicingDefaultSettlementDate | undefined
) => {
  const date = dayjs(invoicingDate)
  if (rule === 'invoice_date') {
    return date.format('YYYY-MM-DD')
  }
  return date.startOf('month').subtract(1, 'day').format('YYYY-MM-DD')
}
